module.exports = __webpack_public_path__ + "static/media/PCM_login.f3c27705.png";